import React, { useEffect, useState } from 'react'
import NavigationBar from "../../components/Navigationbar/Navigationbar";
import { Autocomplete, Card, Link, Tab, Table, TabList, TabPanel, Tabs, Typography } from '@mui/joy';
import Headline from '../../components/headline/Headline';
import { post, Token } from '../../Script/Session';
import { useNavigate } from 'react-router-dom';
import AktivityCreator from './components/AktivityCreator';
function Aktivitäten() {
  const [wit, setWit] = useState("90.5%");
  const [index, setIndex] = React.useState(0);
  const [data, setdata] = useState();
  const navigation = useNavigate();
  useEffect(() => {
    let body = {};
    body.token = Token.get();
    body.action = "getlist";
    let response = post(body, "/aktivitäten");
    if (response == "LOGOUT") {
      navigation("/");
    }
    console.log(response)
    setdata(JSON.parse(response)?.result);

  }, []);
  return (
    <>
      <div style={{ width: wit, position: "fixed", flexDirection: "column", top: "0", right: "0", height: "100vh", display: "flex", alignItems: "center", }}>
        <Headline title={"Aktivitäten"} />
        <Tabs
          aria-label="Vertical tabs"
          orientation="vertical"
          sx={{ minWidth: "100%", height: "100vh" }}
          value={index}
          onChange={(event, value) => {
            setIndex(value)
          }}
        >
          <TabList>
            <Tab>Anstehende Aktivitäten</Tab>
            <Tab>Archiv</Tab>
            <Tab>Aktivität erstellen</Tab>
          </TabList>
          <TabPanel value={0}>
            <Table>
              <thead>
                <tr>
                  <th>Anmeldung Möglich</th>
                  <th>Angemeldet</th>
                  <th>Datum/Zeit</th>
                  <th>Vorausichtliches Ende</th>
                  <th>Veranstaltung</th>
                  <th>Teilnehmer</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {
                  data && data.sort((a,b) => b.ende - a.ende).filter((a) => a.ende >= Date.now())?.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td>{item.kannanmelden ? "Ja" : "Nein"}</td>
                        <td>{item.angemeldet ? "Ja" : "Nein"}</td>
                        <td>{new Date(item.datum).toISOString().slice(0, 16).replace("T", " ")}</td>
                        <td>{new Date(item.ende).toISOString().slice(0, 16).replace("T", " ")}</td>
                        <td>{item.title}</td>
                        <td>Funktionen: {item.angemeldetefunktionen.map((i) => {
                          return (<Typography>{i},</Typography>)
                        })}
                          Personen:
                          {item.angemeldete.map((i) => {
                            return (<Typography>{i.vorname} {i.nachname}</Typography>)
                          })}
                        </td>
                        <td><Link href={window.location.origin + "/aktivityviewer/" + item.id}>Details</Link></td>
                      </tr>
                    )



                  })
                }


              </tbody>
            </Table>


          </TabPanel>
          <TabPanel value={1}>
            <Table>
              <thead>
                <tr>
                  <th>Anmeldung Möglich</th>
                  <th>Angemeldet</th>
                  <th>Datum/Zeit</th>
                  <th>Vorausichtliches Ende</th>
                  <th>Veranstaltung</th>
                  <th>Teilnehmer</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {
                  data && data.sort((a,b) => b.ende - a.ende).filter((a) => a.ende < Date.now()).map((item) => {
                    return (
                      <tr key={item.id}>
                        <td>{item.kannanmelden ? "Ja" : "Nein"}</td>
                        <td>{item.angemeldet ? "Ja" : "Nein"}</td>
                        <td>{new Date(item.datum).toISOString().slice(0, 16)}</td>
                        <td>{new Date(item.ende).toISOString().slice(0, 16)}</td>
                        <td>{item.title}</td>
                        <td>Funktionen: {item.angemeldetefunktionen.map((i) => {
                          return (<Typography>{i},</Typography>)
                        })}
                          Personen:
                          {item.angemeldete.map((i) => {
                            return (<Typography>{i.vorname} {i.nachname}</Typography>)
                          })}
                        </td>
                        <td><Link href={window.location.origin + "/aktivityviewer/" + item.id}>Details</Link></td>
                      </tr>
                    )



                  })
                }


              </tbody>
            </Table>
                

          </TabPanel>
          <TabPanel sx={{overflowY: "auto"}} value={2}>
                <AktivityCreator/>
          </TabPanel>

        </Tabs>
      </div>
      <NavigationBar state={"home"} back={false} />
    </>
  )
}

export default Aktivitäten
